import { getParameters } from '../../../helpers/helpers';
import { LINK_CG_TERMINAL_FORM } from './form-tcg-types';

import { linkTerminaltoCardGroup } from './linkTerminalCardGroup/link-terminal-to-card-group';
import { linkCardGrouptoTerminal } from './linkCardGroupTerminal/link-card-group-to-terminal';

/**
 * Directs the Link Card Groups and Terminal form functionality based on 
 * linkAction param
 * 
 * @returns void
 */
export const formTerminalCardGroup = () => {
  if ( !LINK_CG_TERMINAL_FORM.addCGTLink ) return;

  const linkAction = getParameters('linkAction');
  const customerID = getParameters('customerId');
  const partnerID = getParameters('partnerID');
  const terminalID = getParameters('terminalID');
  const cardGroupID = getParameters('cardGroupID');

  switch(linkAction) {
    case 'terminal':
      linkTerminaltoCardGroup(terminalID, customerID, partnerID);
      break;
    case 'cardgroup':
      linkCardGrouptoTerminal( customerID, cardGroupID );
      break;
  };
}